import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import {format as stringFormat} from 'react-string-format';

import { MSG_NOT_FOUND, MSG_TRAVEL_FIELD_ADD_SUCCESS, MSG_TRAVEL_FIELD_ADD_ERROR, MSG_TRAVEL_FIELD_MODIFY_SUCCESS, MSG_TRAVEL_FIELD_MODIFY_ERROR, MSG_TRAVEL_FIELD_DELETE_SUCCESS, MSG_TRAVEL_FIELD_DELETE_ERROR,  MSG_TM_FIELD_DELETE_MSG, MSG_TM_FIELD_DELETE_MSG2, MSG_TM_FIELD_ADD_DUPLICATE } from '../../configs/msgConfigs';
import {LBL_ADD_NEW,LBL_APP_NAME,LBL_SETTINGS,LBL_ACTIONS,LBL_SLNUM,LBL_TRAVEL_MODULE_FIELDS_AFFILIATES,LBL_CONFIRM_DELETE,LBL_SELECT, LBL_BACK_TO_SETTINGS, LBL_TM_FIELD_NAME, LBL_TM_FIELD_CALC, LBL_TM_CALC_METHOD, LBL_ADD, LBL_EDIT, LBL_DELETE } from '../../configs/labelConfigs';   
import {ROUTE_REFRESH,LOGIN_AFFILIATE_GROUP,LOGIN_SUPER_ADMIN_GROUP,ROUTE_SA_SETTINGS, TM_CALULATION_FIELDS, TM_FIELD_ADD_ERROR_CODE} from '../../configs/staticConfigs';
import {SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS, SA_TRAVEL_FIELDS_MASTER_LIST_ERROR, SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS, SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR, SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS, SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR} from '../../actions';

import ModalWindow from '../commons/helpers/modalWindow';
import Toast from '../commons/helpers/toast';

import {travelFieldsMasterListAction, travelFieldCreateAction, travelFieldModifyAction, travelFieldDeleteAction} from '../../actions/settings/travelModuleActions';
import {clearAction} from '../../actions/commonActions';

import deleteIcon from "../../assets/images/deleteIcon.svg";

class TravelModuleFieldsComponent extends Component { 

    constructor(props){
        super()

        this.state = {            
            activeRowId:0,   
            fieldData: {
               field_id: 0, 
               field_name: '', 
               field_type: 0
            }, 
            selectedFieldId: 0, 
            selectedFieldName: '', 
            calculationMethodString: '',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            userGroup: '',
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);

        this.modalDelete = React.createRef();
        this.modal       = React.createRef();
        
    }    

    onModalFormReset = () =>{       
        this.setState({fieldData:{
            field_id: 0, 
            field_name: '', 
            field_type: 0
        }, 
        calculationMethodString: '', 
        selectedFieldId: 0, 
        selectedFieldName: '', 
    }); 
    }

    openModal() { 
        this.onModalFormReset(); 
        this.modal.current.handleOpenModal();
    }    

    onHandleChange = (event) =>{
        const {name} = event.target;
        let value = event.target.value; 
        let fieldData   = this.state.fieldData;
        fieldData[name] = value;
        this.setState({fieldData}, () => {
            if(this.state.fieldData.field_name.trim() !=='' && Number(this.state.fieldData.field_type)) {
                let calcMethod = this.state.fieldData.field_name + ' * ' +TM_CALULATION_FIELDS.filter(item => Number(item.fieldId)===Number(this.state.fieldData.field_type))[0].calculationMethod;
                this.setState({calculationMethodString: calcMethod}); 
            }
        });
    }    

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }
    }    

    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSaveFormData = (id) => {
        let fieldData = this.state.fieldData;
        if(fieldData.field_name.trim().length > 0 && Number(fieldData.field_type) > 0) {
            if( Number(fieldData.field_id) > 0) {
                this.props.travelFieldModifyAction({field_id: fieldData.field_id, field_name: fieldData.field_name, field_type: fieldData.field_type});  
            } else {
                this.props.travelFieldCreateAction({field_name: fieldData.field_name, field_type: fieldData.field_type});
            }
        } 
    }    
    
    editBtnClick = (fieldId) =>{        
        this.modal.current.handleOpenModal();
    }

    deleteBtnClick = (fId,fName) =>{
        this.setState({
            selectedFieldId: fId, 
            selectedFieldName: fName
        }, () => {
            this.modalDelete.current.handleOpenModal();
        }); 
    }

    onDeleteAction = () =>{
        this.props.travelFieldDeleteAction({field_id:this.state.selectedFieldId});
        // this.modalDelete.current.handleModelClose();                    
    }    

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }   

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    onSelectAddnewCheckbox = (event,docId) => { 
        let arrTemp = this.state.addNewDocIds; 
        if(event.target.checked) {
            if(!arrTemp.includes(docId)) {
                arrTemp.push(docId); 
            }
            this.setState({ addNewdocIds: arrTemp });
        }
        else {
            const index = arrTemp.indexOf(docId);
            if (index > -1) { 
                arrTemp.splice(index, 1); 
            }
            this.setState({ addNewDocIds: arrTemp });
        }            
    }
  
    // if(activity===types.USER_DOC_ADD_ERROR){ 
    //     if(status===400){
    //         if(errorData.hasOwnProperty('name')){
    //             // 
    //         }else{
    //             this.modal.current.handleModelClose();
    //             this.setToasterState(true,JSON.stringify(errorData),false);
    //         }
    //     }  
    // }
    
    componentDidUpdate(prevProps) {    
        const { errorData,travelModuleStatus,travelModuleActivity} = this.props; 
        
        if (travelModuleActivity !== prevProps.travelModuleActivity) {
            var arrTmpResp = travelModuleActivity.split('~~');
            var tmpString = arrTmpResp[0];
            if(tmpString===SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS) {
                console.log('list success'); 
            } else if(tmpString===SA_TRAVEL_FIELDS_MASTER_LIST_ERROR) {
                console.log('list error'); 
            } else if(tmpString===SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS) {
                this.props.travelFieldsMasterListAction(); 
                this.setToasterState(true,MSG_TRAVEL_FIELD_ADD_SUCCESS,true);
                this.modal.current.handleModelClose(); 
            } else if(tmpString===SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR) {
                console.log('travelModuleStatus: ',travelModuleStatus); 
                console.log('traveTM_FIELD_ADD_ERROR_CODElModuleStatus: ',TM_FIELD_ADD_ERROR_CODE); 
                this.setToasterState(true,(travelModuleStatus===TM_FIELD_ADD_ERROR_CODE ? MSG_TM_FIELD_ADD_DUPLICATE : MSG_TRAVEL_FIELD_ADD_ERROR),false);
                this.modal.current.handleModelClose(); 
            } else if(tmpString===SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS) {
                this.props.travelFieldsMasterListAction(); 
                this.setToasterState(true,MSG_TRAVEL_FIELD_DELETE_SUCCESS,true);
                this.modalDelete.current.handleModelClose(); 
            } else if(tmpString===SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR) {
                this.setToasterState(true,MSG_TRAVEL_FIELD_DELETE_ERROR,false);
                this.modalDelete.current.handleModelClose(); 
            } 
            
            // MSG_TRAVEL_FIELD_MODIFY_SUCCESS, MSG_TRAVEL_FIELD_MODIFY_ERROR, 

            this.props.clearAction();
        }       
    }     
  
    componentDidMount() {
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        this.props.travelFieldsMasterListAction(); 
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_TRAVEL_MODULE_FIELDS_AFFILIATES;
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
        this.setState({userGroup:userGroup}); 
    }
    
    render(){

        const {
            toastMessage,toastFlag,toastSuccess        
        } = this.state    
        
        const { travelModuleMasterFields,travelModuleStatus} = this.props;       

        if(travelModuleStatus===401 || travelModuleStatus===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        return(
            <div className="col-md-8">
                 <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">
                            <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)}>{LBL_ADD_NEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table docs" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                        <th>{LBL_SLNUM}</th>
                                        <th>{LBL_TM_FIELD_NAME}</th>
                                        <th>{LBL_TM_FIELD_CALC}</th>
                                        <th>{LBL_TM_CALC_METHOD}</th>
                                        <th className='text-center'>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(!travelModuleMasterFields || !Array.isArray(travelModuleMasterFields) || travelModuleMasterFields.length===0) &&
                                    <tr>
                                        <td colSpan="5" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                { travelModuleMasterFields && Array.isArray(travelModuleMasterFields) && travelModuleMasterFields.map((item,index) => {
                                    let fieldType = TM_CALULATION_FIELDS.filter(tmpItem => Number(tmpItem.fieldId)===Number(item.field_type))[0].fieldName;
                                    let calcMethodStr = item.field_name + ' * ' +TM_CALULATION_FIELDS.filter(tmpItem => Number(tmpItem.fieldId)===Number(item.field_type))[0].calculationMethod;

                                    return (
                                        <tr key={item.id}>
                                            <td>{index+1}</td>
                                            <td>{item.field_name}</td>
                                            <td>{fieldType}</td>
                                            <td><small>{'( '+calcMethodStr+' )'}</small></td>
                                            <td className='text-center' >
                                                <img src={deleteIcon} title={LBL_DELETE} alt={LBL_DELETE} className="mb-1 spanPointer" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.field_name)} />
                                                {/*
                                                <div className="dropdown" id={'dropdown-'+item.id}><button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                     {this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP && <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>Edit</Link>} 
                                                    <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.field_name)}>{LBL_DELETE}</Link>
                                                </div>
                                                </div>
                                                */}
                                            </td>
                                        </tr>             
                                     )
                                  })      
                                }                     
                                </tbody>
                            </table>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    <>
                        <div>{MSG_TM_FIELD_DELETE_MSG}</div>
                        <div>{stringFormat(MSG_TM_FIELD_DELETE_MSG2,this.state.selectedFieldName)}</div>
                    </>
                
                </ModalWindow>

                <ModalWindow ref={this.modal} header={Number(this.state.fieldData.field_id) > 0 ? (LBL_EDIT+' '+LBL_TRAVEL_MODULE_FIELDS_AFFILIATES) : (LBL_ADD+' '+LBL_TRAVEL_MODULE_FIELDS_AFFILIATES)} saveFormData={ (e)=>this.onSaveFormData(this.state.fieldData.field_id)} resetModalForm={this.onModalFormReset} autoFocusField='field_name' >
                    
                    <><div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_TM_FIELD_NAME}</label>
                                <div className="text-input"><input className={this.state.fieldData.field_name.trim().length===0 ? "input-error" : ''} name="field_name" id="field_name" type="text" placeholder={LBL_TM_FIELD_NAME}  value={this.state.fieldData.field_name || ''} onChange={this.onHandleChange} maxLength={60} autoFocus={true} /></div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label>{LBL_TM_FIELD_CALC}</label>
                            <div className="form-group select-input">
                                <select name={"field_type"} id={"field_type"} onChange={(e) => this.onHandleChange(e)} value={this.state.fieldData.field_type} className={Number(this.state.fieldData.field_type) === 0 ? "input-error" : ''} >
                                    <option key={'0'} value='0'>{LBL_SELECT}</option>
                                    {TM_CALULATION_FIELDS.map((item) => <option key={item.fieldId} value={item.fieldId}>{item.fieldName}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-10">
                            <label>{LBL_TM_CALC_METHOD} : </label>
                            <div className="form-group">
                                <span><small>{this.state.calculationMethodString.trim().length ? ('( '+this.state.calculationMethodString+' ) ') : ''}</small></span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        &nbsp; 
                    </div>
                    </>
                </ModalWindow>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        travelModuleMasterFields : state.travelModule.travelModuleMasterFields, 
        travelModuleStatus : state.travelModule.travelModuleStatus, 
        travelModuleActivity : state.travelModule.travelModuleActivity, 
        errorData:state.travelModule?.errorData
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        travelFieldsMasterListAction: travelFieldsMasterListAction,
        travelFieldCreateAction:data=>travelFieldCreateAction(data),
        travelFieldModifyAction:data=>travelFieldModifyAction(data),
        travelFieldDeleteAction:id =>travelFieldDeleteAction(id),
        clearAction:clearAction           
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(TravelModuleFieldsComponent);